/** @format */
import {
    AuthService,
    AuthTokenInterceptorService,
    DowngradedComponent,
    DowngradedService,
    ModalService,
    ServiceBootstrapComponent,
    TokenStorageService,
    UuidService,
} from 'sis-common';
import {
    AboutComponent,
    AlertsComponent,
    AlertsService,
    AppErrorHandler,
    ApplicationAttachmentEntityService,
    ApplicationFilesComponent,
    AttainedCreditsByStudyTermComponent,
    AttainmentApplicationStructureComponent,
    AttainmentEditModalService,
    AttainmentEntityService,
    AttainmentRowMenuButtonComponent,
    AttainmentTreeAttainmentComponent,
    AttainmentWorkflowDecisionSummaryComponent,
    BasicGroupingPanelComponent,
    BreadcrumbsComponent,
    CheckboxComponent,
    CodeSelectEditorComponent,
    CodeSelectionEditorComponent,
    CommonCodeService,
    CommonGradeAverageService,
    CompletionMethodAssessmentItemInfoComponent,
    CompletionMethodAssessmentItemsDetailsComponent,
    CompletionMethodRepeatsComponent,
    ConfirmDialogService,
    ContactInfoForGraduationComponent,
    ContextualNotificationComponent,
    CourseUnitBoxComponent,
    CourseUnitCrossStudyComponent,
    CourseUnitEntityService,
    CourseUnitInfoModalTextFieldComponent,
    CourseUnitRealisationSeatsComponent,
    CourseUnitSearchComponent,
    CourseUnitVersionSelectorComponent,
    CustomCodeUrnsComponent,
    DegreeProgrammeAttainmentApplicationAnswersComponent,
    DegreeProgrammeEntityService,
    DisabledLinkComponent,
    DropdownSelectButtonComponent,
    DropdownSelectComponent,
    ExtensionInfoComponent,
    ExternalLinkComponent,
    HeaderService,
    IconComponent,
    InlineSearchAdditionalDataRowComponent,
    InternationalContractualDegreeAgreementEntityService,
    LabelWithInfoPopoverComponent,
    LanguagePillsComponent,
    LegacyLocalDateEditorComponent,
    LiteratureComponent,
    LocalizedMarkupStringViewComponent,
    MarkStringComponent,
    MarkupService,
    MarkupStringComponent,
    MarkupStringViewComponent,
    MenuButtonComponent,
    MessageBannerComponent,
    MinorSelectionsComponent,
    MobilityPeriodEntityService,
    ModuleBoxComponent,
    ModuleEntityService,
    ModuleSearchComponent,
    NewPlanSubstitutionService,
    NotificationsService,
    OpenUniversityCartTimerAlertService,
    OrganisationRoleShareComponent,
    OrganisationSettingsService,
    PageTitleComponent,
    PaginationComponent,
    PersonInfoForGraduationComponent,
    PersonRuleService,
    PlanEntityService,
    PlannedStudiesByStudyTermComponent,
    PlanSelectorModalLegacyService,
    PopoverComponent,
    PriorCompetenceSummaryComponent,
    PriorLearningListComponent,
    PriorLearningSubstitutionsComponent,
    PriorStudiesSummaryComponent,
    PrivatePersonBasicInfoEntityService,
    PrivatePersonEntityService,
    ReadMoreNgComponent,
    SearchFilterCourseUnitComponent,
    SearchFilterEducationComponent,
    SearchFilterModuleComponent,
    SearchFilterOptionsMenuComponent,
    SearchFilterOrganisationComponent,
    SearchInOrderService,
    SearchUtilsService,
    ServiceBreakService,
    ShowMoreComponent,
    SisMessageConversationComponent,
    SisMessageConversationsComponent,
    SisPlanMessagesComponent,
    SisServiceBreakBannerComponent,
    SkipLinkComponent,
    SortableTableColumnHeaderComponent,
    SortByIndicatorComponent,
    StudentWorkflowListComponent,
    StudyModuleEntityService,
    StudyRightStatusBadgeComponent,
    StudySelectorService,
    TabContentSwitchComponent,
    TabNavigationComponent,
    TermRegistrationRequirementsEntityService,
    TinyBadgeComponent,
    TooltipComponent,
    TranspileComponent,
    TuitionFeeObligationPeriodEntityService,
    TypeaheadComponent,
    UiRouterService,
    UnauthorizedComponent,
    UniversityIframeComponent,
    UniversitySelectEditorComponent,
    UserSettingsEntityService,
    ValidationErrorHandlerService,
    VersionSelectorComponent,
    WorkflowDataChangeService,
    WorkflowEntityService,
} from 'sis-components';
import { FullCalendarMessageService } from './calendar/full-calendar/full-calendar-message.service';
import { FullCalendarComponent } from './calendar/full-calendar/full-calendar.component';
import { CourseUnitAttainmentNotificationComponent } from './common/components/course-unit-attainment-notification/course-unit-attainment-notification.component';
import { CourseUnitGradeRaiseInfoComponent } from './common/components/course-unit-grade-raise-info/course-unit-grade-raise-info.component';
import { CourseUnitInfoHeaderComponent } from './common/components/course-unit-info-as-page/course-unit-info-header/course-unit-info-header.component';
import { CourseUnitInfoModalHeaderComponent } from './common/components/course-unit-info-modal/course-unit-info-modal-header/course-unit-info-modal-header.component';
import { CourseUnitInfoModalSubstitutionsComponent } from './common/components/course-unit-info-modal/course-unit-info-modal-substitutions/course-unit-info-modal-substitutions.component';
import { CourseUnitRealisationInfoComponent } from './common/components/course-unit-info-modal/course-unit-realisation/course-unit-realisation-info/course-unit-realisation-info.component';
import { StudentCourseUnitRealisationStructureComponent } from './common/components/course-unit-info-modal/course-unit-realisation/student-course-unit-realisation-structure/student-course-unit-realisation-structure.component';
import { CourseUnitInfoBrochureComponent } from './common/components/course-unit-info/course-unit-info-brochure/course-unit-info-brochure.component';
import { CourseUnitSelectionInfoComponent } from './common/components/course-unit-selection-info/course-unit-selection-info.component';
import { EnrolmentStateIndicatorComponent } from './common/components/enrolment/enrolment-state-indicator/enrolment-state-indicator.component';
import { ProcessingStateIndicatorComponent } from './common/components/enrolment/processing-state-indicator/processing-state-indicator.component';
import { ModuleInfoModalService } from './common/components/module-info/module-info-modal.service';
import { MyPlanSelectComponent } from './common/components/my-plan-select/my-plan-select.component';
import { ApplyForModuleContentWorkflowComponent } from './common/components/show-view-module-content-application-link/apply-for-module-content-workflow/apply-for-module-content-workflow.component';
import { CourseCartEntityService } from './common/service/course-cart-entity.service';
import { EnrolmentStudentService } from './common/service/enrolment-student.service';
import { StudentPlanOutdatedCourseUnitsService } from './common/service/student-plan-outdated-course-units.service';
import { PreviewModeService } from './common/utils/preview-mode.service';
import { UiStateStoreService } from './common/utils/ui-state-store.service';
import { CourseCartComponent } from './course-cart/course-cart.component';
import { EnrolmentWizardComponent } from './enrolments/enrolment-wizard/enrolment-wizard.component';
import { EnrolmentsMainContainerComponent } from './enrolments/enrolments-main-container/enrolments-main-container.component';
import { StudentTermRegistrationPeriodInfoComponent } from './frontpage/student-term-registration-period-info/student-term-registration-period-info.component';
import { StudyRightExpirationInfoComponent } from './frontpage/study-right-expiration-info/study-right-expiration-info.component';
import { StudentMessageConversationsListComponent } from './message-conversations/student-message-conversations-list.component';
import { OpenUniversityOfferingComponent } from './open-university/study-offering/open-university-offering/open-university-offering.component';
import { PlanVersionToggleComponent } from './plan-ng/plan-version-toggle/plan-version-toggle.component';
import { EmrexResultModalService } from './plan/emrex-result-modal/emrex-result-modal.service';
import { CreateCustomStudyDraftModalWrapperComponent } from './plan/freeEdit/create-custom-study-draft-modal-wrapper/create-custom-study-draft-modal-wrapper.component';
import { OutdatedCourseUnitsModalService } from './plan/outdated-course-units-modal/outdated-course-units-modal.service';
import { AnyCourseUnitRuleRipaCheckboxComponent } from './plan/rules/any-course-unit-rule-ripa-checkbox/any-course-unit-rule-ripa-checkbox.component';
import { SelectEmrexAccessPointModalService } from './plan/select-emrex-access-point-modal/select-emrex-access-point-modal.service';
import { PriorLearningWorkflowContentComponent } from './profile/applications/prior-learning-workflow-content/prior-learning-workflow-content.component';
import { AttainmentDetailsModalComponent } from './profile/attainment/attainment-details/attainment-details-modal/attainment-details-modal.component';
import { ProfileSecondaryNavigationComponent } from './profile/profile-secondary-navigation/profile-secondary-navigation.component';
import { EnrolmentRightStudentStudyRightComponent } from './profile/studyRights/enrolment-right-student-study-right/enrolment-right-student-study-right.component';

/**
 * Angular -> AngularJS downgraded components for the student frontend.
 *
 * If you need to downgrade a new component, just add it to this list. We only have one downgraded root module, and all components
 * are registered to it regardless of which Angular module they belong to.
 */
export const downgradedComponents: DowngradedComponent[] = [
    AboutComponent,
    AlertsComponent,
    ApplicationFilesComponent,
    AttainmentTreeAttainmentComponent,
    BasicGroupingPanelComponent,
    BreadcrumbsComponent,
    CheckboxComponent,
    ContactInfoForGraduationComponent,
    ContextualNotificationComponent,
    CourseCartComponent,
    CourseUnitBoxComponent,
    CourseUnitSearchComponent,
    CourseUnitCrossStudyComponent,
    CourseUnitRealisationSeatsComponent,
    CourseUnitVersionSelectorComponent,
    DegreeProgrammeAttainmentApplicationAnswersComponent,
    DisabledLinkComponent,
    DropdownSelectButtonComponent,
    DropdownSelectComponent,
    EnrolmentStateIndicatorComponent,
    PriorLearningSubstitutionsComponent,
    ExtensionInfoComponent,
    ExternalLinkComponent,
    EnrolmentWizardComponent,
    IconComponent,
    LabelWithInfoPopoverComponent,
    LegacyLocalDateEditorComponent,
    LiteratureComponent,
    LocalizedMarkupStringViewComponent,
    MarkupStringViewComponent,
    MenuButtonComponent,
    MinorSelectionsComponent,
    ModuleBoxComponent,
    ModuleSearchComponent,
    OpenUniversityOfferingComponent,
    EnrolmentRightStudentStudyRightComponent,
    OrganisationRoleShareComponent,
    PageTitleComponent,
    CourseUnitSelectionInfoComponent,
    CourseUnitGradeRaiseInfoComponent,
    CourseUnitAttainmentNotificationComponent,
    PaginationComponent,
    PersonInfoForGraduationComponent,
    MyPlanSelectComponent,
    PlannedStudiesByStudyTermComponent,
    PopoverComponent,
    PriorLearningListComponent,
    ProcessingStateIndicatorComponent,
    ProfileSecondaryNavigationComponent,
    SearchFilterEducationComponent,
    SearchFilterModuleComponent,
    SearchFilterOptionsMenuComponent,
    SearchFilterOrganisationComponent,
    ServiceBootstrapComponent,
    ShowMoreComponent,
    SisMessageConversationComponent,
    SisMessageConversationsComponent,
    SisPlanMessagesComponent,
    SisServiceBreakBannerComponent,
    SkipLinkComponent,
    SortByIndicatorComponent,
    SortableTableColumnHeaderComponent,
    StudentMessageConversationsListComponent,
    StudyRightExpirationInfoComponent,
    StudyRightStatusBadgeComponent,
    TabContentSwitchComponent,
    TabNavigationComponent,
    TooltipComponent,
    TypeaheadComponent,
    UnauthorizedComponent,
    UniversitySelectEditorComponent,
    AttainmentApplicationStructureComponent,
    StudentTermRegistrationPeriodInfoComponent,
    PriorStudiesSummaryComponent,
    PriorCompetenceSummaryComponent,
    StudentWorkflowListComponent,
    CodeSelectEditorComponent,
    CodeSelectionEditorComponent,
    LanguagePillsComponent,
    StudentCourseUnitRealisationStructureComponent,
    PriorLearningWorkflowContentComponent,
    AttainmentWorkflowDecisionSummaryComponent,
    VersionSelectorComponent,
    CompletionMethodAssessmentItemInfoComponent,
    CompletionMethodAssessmentItemsDetailsComponent,
    CompletionMethodRepeatsComponent,
    CourseUnitInfoBrochureComponent,
    CourseUnitInfoHeaderComponent,
    CourseUnitInfoModalHeaderComponent,
    CourseUnitInfoModalTextFieldComponent,
    CustomCodeUrnsComponent,
    EnrolmentsMainContainerComponent,
    MarkupStringComponent,
    AnyCourseUnitRuleRipaCheckboxComponent,
    InlineSearchAdditionalDataRowComponent,
    AttainmentDetailsModalComponent,
    MessageBannerComponent,
    CourseUnitInfoModalSubstitutionsComponent,
    TinyBadgeComponent,
    AttainmentRowMenuButtonComponent,
    SearchFilterCourseUnitComponent,
    MarkStringComponent,
    ApplyForModuleContentWorkflowComponent,
    ReadMoreNgComponent,
    TranspileComponent,
    FullCalendarComponent,
    AttainedCreditsByStudyTermComponent,
    UniversityIframeComponent,
    CreateCustomStudyDraftModalWrapperComponent,
    CourseUnitRealisationInfoComponent,
    PlanVersionToggleComponent,
];

/**
 * Angular -> AngularJS downgraded service registrations for the student frontend.
 *
 * If you need to downgrade a new service, just add it to this list. All services should be registered in the app module.
 */
export const downgradedServices: DowngradedService[] = [
    AttainmentEditModalService,
    NotificationsService,
    AlertsService,
    ApplicationAttachmentEntityService,
    HeaderService,
    CommonCodeService,
    CommonGradeAverageService,
    ConfirmDialogService,
    SearchInOrderService,
    OrganisationSettingsService,
    MobilityPeriodEntityService,
    ModalService,
    InternationalContractualDegreeAgreementEntityService,
    PlanSelectorModalLegacyService,
    PrivatePersonEntityService,
    SearchUtilsService,
    ServiceBreakService,
    TermRegistrationRequirementsEntityService,
    TuitionFeeObligationPeriodEntityService,
    UiRouterService,
    UuidService,
    OpenUniversityCartTimerAlertService,
    WorkflowDataChangeService,
    WorkflowEntityService,
    PrivatePersonBasicInfoEntityService,
    AttainmentEntityService,
    ValidationErrorHandlerService,
    StudentPlanOutdatedCourseUnitsService,
    StudyModuleEntityService,
    ModuleEntityService,
    DegreeProgrammeEntityService,
    CourseUnitEntityService,
    MarkupService,
    StudySelectorService,
    AppErrorHandler,
    NewPlanSubstitutionService,
    CourseCartEntityService,
    EnrolmentStudentService,
    PreviewModeService,
    UiStateStoreService,
    ModuleInfoModalService,
    FullCalendarMessageService,
    OutdatedCourseUnitsModalService,
    TokenStorageService,
    AuthService,
    AuthTokenInterceptorService,
    SelectEmrexAccessPointModalService,
    EmrexResultModalService,
    PersonRuleService,
    PlanEntityService,
    UserSettingsEntityService,
];
